import { v4 as uuidv4 } from "uuid";
import { z } from "zod";

import { accountSchema } from "./account";
import { cardSchema } from "./card";
import { metricsSchema } from "./metrics";
import { statusSchema } from "./status";

const nestedAdSchema = z
  .object({
    card: cardSchema,
    account: accountSchema.nullable(),
    metrics: metricsSchema,
  })
  .optional()
  .catch(undefined);

const adSchema = z
  .discriminatedUnion("provider", [
    z.object({
      provider: z.literal("gam"),
      // Unlike nestedAdSchema, metrics is required (useAds drops entities
      // without it) and card/account may be absent, since GPT renders the
      // creative into the ad unit from VITE_GAM_AD_UNIT.
      ad: z.object({
        card: cardSchema.nullish().catch(null),
        account: accountSchema.nullable().catch(null),
        metrics: metricsSchema,
      }),
      status: z.null(),
    }),
    z.object({
      provider: z.literal("rumble"),
      ad: nestedAdSchema.nullable(),
      status: statusSchema.nullable(),
    }),
    z.object({
      provider: z.literal("revcontent"),
      ad: nestedAdSchema,
      status: z.null(),
    }),
  ])
  .transform((ad) => ({
    ...ad,
    id: uuidv4(),
  }));

type Ad = z.infer<typeof adSchema>;

export { adSchema, type Ad };
